import Horses from '@/views/horses/Horses.vue'
import HorseDetail from '@/views/horses/HorseDetail'

export default [
  {
    path: 'caballos',
    name: 'horses.list',
    component: Horses
  },
  {
    path: 'caballos/:id/ficha',
    name: 'horses.detail',
    component: HorseDetail
  }
]
